var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerE(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 135,
    viewBox: "0 0 138 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138 66.1395V76.0604H14.7642C15.48 84.4073 18.4152 92.4108 23.2656 99.2413C28.1161 106.072 34.7053 111.48 42.3499 114.907C65.1218 125.623 94.0469 121.353 117.363 101.763L126.489 112.772C110.567 126.671 90.27 134.537 69.1403 135C57.8562 135.02 46.707 132.547 36.4896 127.758C25.299 122.596 15.8747 114.255 9.39135 103.774C2.90799 93.2935 -0.347881 81.1367 0.0294479 68.8186C0.204187 50.6136 7.51646 33.2044 20.3936 20.3349C33.2708 7.46541 50.6843 0.163671 68.8891 0C106.563 0 137.749 31.3116 137.749 66.1395H138ZM123.265 61.9534C121.13 36.2511 98.1492 14.2744 68.8472 14.2744C39.5453 14.2744 16.606 36.2511 14.7223 61.9534H123.265Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerE);
export default __webpack_public_path__ + "static/media/LOWER_E.fff9a9d208f1c3c1d72d1582bf8dc0ad.svg";
export { ForwardRef as ReactComponent };